import React from 'react';

const ErrorCard = ({ title = 'Failed to load models', message }) => (
  <div className="card-elevated border border-red-200 bg-red-50 w-full min-w-0 overflow-hidden">
    <div className="p-3 md:p-4">
      <div className="text-sm md:text-base font-semibold text-red-800 mb-1">
        {title}
      </div>

      <div className="text-xs sm:text-sm md:text-base text-red-700 break-words">
        {message}
      </div>
    </div>
  </div>
);

export default ErrorCard;
